import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useCallback, useEffect, useState } from 'react';
import { BIG_DESKTOP_WIDTH, MAX_SLIDE_VIEW, MIDDLE_SLIDE_VIEW, MIN_SLIDE_VIEW, SMALL_DESKTOP_WIDTH } from "../constants";
export var usePrepareMainServices = function usePrepareMainServices() {
  var _useState = useState(calculateSettings()),
    _useState2 = _slicedToArray(_useState, 2),
    slidesPerValue = _useState2[0],
    setSlidesPer = _useState2[1];
  var handleResize = useCallback(function () {
    return setSlidesPer(calculateSettings());
  }, []);
  function calculateSettings() {
    if (typeof window !== 'undefined') {
      var currentWidth = window.innerWidth;
      if (currentWidth >= BIG_DESKTOP_WIDTH) {
        return {
          spaceBetween: 24,
          slidesPerView: MAX_SLIDE_VIEW,
          pagination: {
            renderBullet: function renderBullet(_, className) {
              return "<span style=\"background: #434856\" class=\"".concat(className, "\"></span>");
            },
            clickable: true
          }
        };
      }
      if (currentWidth >= SMALL_DESKTOP_WIDTH) {
        return {
          spaceBetween: 24,
          slidesPerView: MIDDLE_SLIDE_VIEW
        };
      }
    }
    return {
      spaceBetween: 16,
      slidesPerView: MIN_SLIDE_VIEW
    };
  }
  useEffect(function () {
    window.addEventListener('resize', handleResize);
    return function () {
      return window.removeEventListener('resize', handleResize);
    };
  }, []);
  return slidesPerValue;
};